import MainLayout from 'layouts/MainLayout';

const ConsultantDashboard = () => {
  return <MainLayout></MainLayout>;
};

export default ConsultantDashboard;
